
import {
  AddNewPQR,
  UpdatePQRHeader,
} from "../../../Services/pqr-header-service";

import { Action, MessageTypes } from "../../utility/common/constants/CommonConstants";
import { checkProcessAdded as commonCheckProcessAdded, validateTestArray, checkDuplicateProcess as commonCheckDuplicateProcess, validateFirstPageFields } from "../../utility/common/TransactionComponents/TransactionValidationUtils";


export const checkPQRProcessAdded = (detailObj) => {

  return commonCheckProcessAdded(detailObj, {
    processField: 'PQR_Process',
    typeField: 'PQR_Type',

    maxRows: 4
  });



};

export const checkProcessAdded = (detailObj) => {

  return commonCheckProcessAdded(detailObj, {
    processField: 'PQR_Process',
    typeField: 'PQR_Type',

    maxRows: 2
  });



};

export const checkTestAdded = (array) => {
  return validateTestArray(array, ['WPQ_WP_TypeOfTest', 'WPQ_WP_Acceptance_Criteria', 'WPQ_WP_Result', 'WPQ_WP_Comments', 'WPQ_WP_Report_Nummber'], 5, { returnCount: false, requireFirstRow: false });
};



export const check_Pqr_Pag3_VEX = (Visual_Examination, rowCount) => {
  return validateTestArray(Visual_Examination, ['PQR_VEX_WeldPass', 'PQR_VEX_Acceptance_Criteria', 'PQR_VEX_Observation', 'PQR_VEX_Results'], rowCount - 1, { returnCount: true, requireFirstRow: false });
};

export const check_Pqr_Pag3_LPEX = (Liquid_Penetrant_Examination) => {
  return validateTestArray(Liquid_Penetrant_Examination,
    ['PQR_LPEX_WeldPass', 'PQR_LPEX_Acceptance_Criteria',
      'PQR_LPEX_Observation', 'PQR_LPEX_Results'], 3, { returnCount: true, requireFirstRow: false });
};


export const check_Pqr_Pag3_MEX = (Macro_Examination1) => {
  return validateTestArray(Macro_Examination1, ['PQR_MEX_Tube_No', 'PQR_MEX_LocA', 'PQR_MEX_LocB', 'PQR_MEX_LocC', 'PQR_MEX_LocD'], 4, { returnCount: true, requireFirstRow: false });
};
export const check_Pqr_Page4_MLP = (Minimum_Leak_Path1) => {
  return validateTestArray(Minimum_Leak_Path1, ['PQR_MLP_Tube_No', 'PQR_MLP_LocA', 'PQR_MLP_LocB', 'PQR_MLP_LocC', 'PQR_MLP_LocD'], 4, { returnCount: true, requireFirstRow: false });
};


export const page1characters = (error) => {
  let data = true;
  if (
    error.WPQ_WelderId.status === true ||
    error.WPQ_WelderName.status === true ||
    error.WPQ_Date.status === true ||
    error.WPQ_RecordNo.status === true ||
    error.WPQ_Wps_RecordNo.status === true ||
    error.WPQ_ReviNo.status === true ||
    error.WPQ_Inspection.status === true ||
    error.WPQ_Qualificationcode.status === true
  )
    return data;
};

export const checkduplicateProcess = (detailObj) => {
  return commonCheckDuplicateProcess(detailObj, {
    processField: 'PQR_Process',
    typeField: 'PQR_Type'
  });
};

export const checkFirstPageValidation = (radio, ANo, ChemicalAnalysis_TradeName, Classification, FNo, SFA, seterrobj) => {
  return validateFirstPageFields(radio, { ANo, ChemicalAnalysis_TradeName, Classification, FNo, SFA }, seterrobj);
};


export const checkPQRTubeProcessAdded = (detailObj) => {
  return commonCheckProcessAdded(detailObj, {
    processField: 'PQR_Process',
    fNoField: 'WPSD_FM_FNo',
    SFAfield: 'WPSD_FM_SFA',
    maxRows: 1
  });
}

export const checkduplicateTubeProcess = (detailObj) => {
  return commonCheckDuplicateProcess(detailObj, {
    processField: 'WPQ_Process',
    typeField: 'PQR_Type',
    additionalField: 'WPSD_FM_SFA'
  });
};

export const check_Pqr_Page4_Tear = (Tear_Test) => {
  return validateTestArray(Tear_Test, ['PQR_Tear_TubeNo', 'PQR_Tear_Observation', 'PQR_Tear_Results'], 4, { returnCount: true, requireFirstRow: false });
};

export const check_Pqr_Page4_PullOut = (PullOut_Test) => {
  return validateTestArray(PullOut_Test, ['PQR_PullOut_TubeNo', 'PQR_PullOut_Location', 'PQR_PullOut_Load', 'PQR_PullOut_Fracture'], 4, { returnCount: true, requireFirstRow: false });
};



export const check_Pqr_Page4_PullOut_Table = (PullOut_Test_Table) => {
  return validateTestArray(PullOut_Test_Table, ['PQR_PullOut_Acceptance_Criteria', 'PQR_PullOut_Observation', 'PQR_PullOut_Results'], 4, { returnCount: true, requireFirstRow: false });
};

export const check_Pqr_Page4_Hardness = (Hardness_Test) => {
  return validateTestArray(Hardness_Test, ['PQR_HT_TypeofTest', 'PQR_HT_Tube_No', 'PQR_HT_BM_Tubesheet', 'PQR_HT_HAZ_Tubesheet', 'PQR_HT_Weld', 'PQR_HT_HAZ_Tube', 'PQR_HT_BM_Tube', 'PQR_HT_Results'], 9, { returnCount: true, requireFirstRow: false });
};



export const check_Pqr_Page4_Radio = (Radiography_Test) => {
  return validateTestArray(Radiography_Test, ['PQR_Radio_TubeNo', 'PQR_Radio_Acceptance_Criteria', 'PQR_Radio_Observation', 'PQR_Radio_Results'], 4, { returnCount: true, requireFirstRow: false });
};



export const check_Pqr_Page4_OT = (Other_Test, rowCount) => {
  return validateTestArray(Other_Test, ['PQR_OT_TypeofTest', 'PQR_OT_Acceptance_Criteria', 'PQR_OT_Remarks', 'PQR_OT_Results'], rowCount, { returnCount: true, requireFirstRow: false });
};


export const PQR_Page2_Tensile = (Tensile_Test, rowCount) => {
  return validateTestArray(Tensile_Test, ['PQR_Tensile_SpecimenNo', 'PQR_Tensile_Width', 'PQR_Tensile_Thickness', 'PQR_Tensile_Area', 'PQR_Tensile_UltimateLoad', 'PQR_Tensile_UltimateStress', 'PQR_Tensile_FailureLocation'], rowCount - 1, { returnCount: true, requireFirstRow: false });
};

export const PQR_Page2_Certification = (Certification, rowCount) => {
  return validateTestArray(Certification, ['PQR_Certification_Welder_Name', 'PQR_Certification_ID', 'PQR_Certification_Process'], rowCount, { returnCount: true, requireFirstRow: false });
};
export const PQR_Page2_CertificationLabRef = (CertificationLabRef, rowCount) => {
  return validateTestArray(CertificationLabRef, ['PQR_Certification_Lab_RefNo'], rowCount, { returnCount: true, requireFirstRow: false });
};

export const PQR_Page2_Other_test = (Other_Test, rowCount) => {
  return validateTestArray(Other_Test, ['PQR_OT_TypeofTest', 'PQR_OT_Acceptance_Criteria', 'PQR_OT_Results', 'PQR_OT_Remarks'], rowCount, { returnCount: true, requireFirstRow: false });
};

export const PQR_Page2_Other_test_overlay = (Other_Test_overlay, rowCount) => {
  return validateTestArray(Other_Test_overlay, ['PQR_OT_TypeofTest', 'PQR_OT_Acceptance_Criteria', 'PQR_OT_Results', 'PQR_OT_Remarks'], rowCount, { returnCount: true, requireFirstRow: false });
};

export const PQR_Page2_Guided = (GuidedBend_Test, rowCount) => {
  return validateTestArray(GuidedBend_Test, ['PQR_GB_TypeofTest', 'PQR_GB_Acceptance_Criteria', 'PQR_GB_Results', 'PQR_GB_Remarks'], rowCount, { returnCount: true, requireFirstRow: false });
};


export const PQR_Page2_Toughness = (Toughness_Test, rowCount) => {
  return validateTestArray(Toughness_Test, ['PQR_TT_SpecimenNo', 'PQR_TT_WeldingProcess', 'PQR_TT_NotchLocation', 'PQR_TT_TestTemp', 'PQR_TT_ImpactValues', 'PQR_TT_Avg', 'PQR_TT_LateralExpansion', 'PQR_TT_Shear'], rowCount - 1, { returnCount: true, requireFirstRow: false });
};

export const PQR_Groove_Page2_Hardness = (Hardness_Test_Groove, rowCount) => {
  return validateTestArray(Hardness_Test_Groove, ['PQR_HT_Type', 'PQR_HT_Location', 'PQR_HT_ParentMetal_Left', 'PQR_HT_HAZ_Left', 'PQR_HT_Weld', 'PQR_HT_HAZ_Right', 'PQR_HT_ParentMetal_Right', 'PQR_HT_Remarks'], rowCount, { returnCount: false, requireFirstRow: false });
};

export const PQR_Page2_Guided_Overlay = (GuidedBend_Test_Overlay, rowCount) => {
  return validateTestArray(GuidedBend_Test_Overlay, ['PQR_GBV_SpecimenNo', 'PQR_GBV_Thickness', 'PQR_GBV_BM_WeldOverlay', 'PQR_GBV_FormerDiam', 'PQR_GBV_BendAngle', 'PQR_GBV_Acceptance_Criteria', 'PQR_GBV_Remarks'], rowCount, { returnCount: false, requireFirstRow: false });
};

export const AddUpdatePQRHeader = async (postAdd, postUpdate, action, setaction) => {

  let results = [],
    checkarray = [];
  let addresult

  if (action === Action.ActionAdd || action === Action.ActionCopy) {
    for (let reqData of postAdd) {

      let result = await AddNewPQR(reqData).catch((error) => {

      });

      if (result !== undefined)
        addresult = result;

    }

    let addPqrcheck = await Promise.resolve(addresult);
    if (addPqrcheck != undefined && addPqrcheck.message == MessageTypes.SpecialCharacters) {
      return MessageTypes.SpecialCharacters;
    }
    if (addPqrcheck != undefined && addPqrcheck.message == "Success")
      setaction(Action.ActionEdit)
  }

  for (let eachTable of postUpdate) {

    let result = await UpdatePQRHeader(eachTable).catch((error) => {

      return false
    });

    if (result !== undefined) results.push(result);
  }
  for (let result of results) {
    try {
      let check = await Promise.resolve(result);
      checkarray = [...checkarray, check];
    } catch (e) {

    }
  }

  if (checkarray.length === 0) {

    return false;
  }
  else if (checkarray.filter((i) => i.message == MessageTypes.SpecialCharacters).length > 0) {

    return MessageTypes.SpecialCharacters
  }
  else {

    return true;
  }
};